import axios from "axios";
import qs from "qs"; // needed for OAuth request
import base64url from "base64url"; // needed to decode OAuth response
// import fs from "fs";
import EventBus from "./eventBus.js";
import FormData from "form-data";

function ipAddress() {
  return axios.get("https://api.ipify.org?format=json");
}

function ipLookup(ipAddress) {
  return axios.get(`https://ipinfo.io/${ipAddress}?token=8ab33e83c45979`);
}

// pickup and dropoff coords like { lat: 0, lon: 0 }
function graphhopperRoute(p, d) {
  var key = `378cee3b-854d-4aba-a9cb-b3c6c41893a4`;
  var p1 = `${p.lat},${p.lon}`;
  var p2 = `${d.lat},${d.lon}`;
  var url = `https://graphhopper.com/api/1/route?point=${p1}&point=${p2}&vehicle=car&debug=false&key=${key}&type=json&points_encoded=true&instructions=false`;
  return axios.get(url, { timeout: 1500 });
}

// function googleMapsRoute(p, d) {
//   var key = `AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss`; //`378cee3b-854d-4aba-a9cb-b3c6c41893a4`;
//   var p1 = `${p.lat},${p.lon}`;
//   var p2 = `${d.lat},${d.lon}`;
//   var url = `https://maps.googleapis.com/maps/api/directions/json?origin=${p1}&destination=${p2}&key=${key}`;
//   return axios.get(url, { timeout: 1500 });
// }

function onemapAddress(postcode) {
  var url = `https://developers.onemap.sg/commonapi/search?searchVal=${postcode}&returnGeom=Y&getAddrDetails=Y&pageNum=1`;
  return axios.get(url);
}

function reverseGeocode(lat, lon) {
  // var url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`;
  // return axios.get(url);
  console.log("reverseGeocode", lat, lon);
  return null;
}

function imgbb(imageFile) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  const form = new FormData();
  form.append("image", imageFile);
  var apiKey = "2df87896b58a623bd6350d09e16d5f3b";
  var url = `https://api.imgbb.com/1/upload?key=${apiKey}`;
  console.log("imgbb post form data", form);
  return axios.post(url, form, config);
}

function imgAWS(data) {
  var endpoint = "https://img-api.tukapp.co/uploadimage";
  var payload = {
    filePath: data.name, // Filename eg. Soba.jpg
    fileBase64: data.content, // content of image, Don't forget to remove --> fileBase64.replace(/^data:image\/[a-z]+;base64,/, "")
    contentType: "image/png",
    businessID: data.businessID,
    pictureType: data.imageType, // type of image eg. menu, receipt, promos
  };
  return axios.post(endpoint, payload);
}

function lineOAuth(code, redirectPath, cookies) {
  if (cookies.isKey("line_user")) {
    console.log(cookies.get("line_user"));
    console.log("Line user is already logged in");
    return;
  }
  var channelID = "1616017577"; // channel_id
  var client_secret = "fe0ea1f3b2797afe0823de2a465a6424"; // read both from env
  var redirect = import.meta.env.VITE_HOST + redirectPath;
  var url = new URL("https://api.line.me/oauth2/v2.1/token");
  const data = {
    grant_type: "authorization_code",
    code: code,
    redirect_uri: redirect,
    client_id: channelID,
    client_secret: client_secret,
  };
  axios
    .post(url, qs.stringify(data), {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((resp) => {
      console.log("OAuth success", resp);
      console.log("decode1", base64url.decode(resp.data.id_token));
      var payload = resp.data.id_token.split(".")[1];
      var decoded = base64url.decode(payload);
      var obj = JSON.parse(decoded);
      var lineUserData = {
        line_user_id: obj.sub,
        line_display_name: obj.name,
        line_profile_picture: obj.picture,
        created_at: new Date().toLocaleString(),
      };
      var str = JSON.stringify(lineUserData);
      console.log(str, lineUserData);
      EventBus.$emit("DEBUG", `user_data: ${str}`);
      EventBus.$emit("LINE_LOGIN_SUCCESS", lineUserData);
    })
    .catch((error) => console.log("ERR:" + error));
}

function vuexLineOAuth(code, redirectPath) {
  // if (cookies.isKey("line_user")) {
  //     console.log("Line user is already logged in");
  //     return
  // }
  var channelID = "1616017577"; // channel_id
  var client_secret = "fe0ea1f3b2797afe0823de2a465a6424"; // read both from env
  var redirect = import.meta.env.VITE_HOST + redirectPath;
  var url = new URL("https://api.line.me/oauth2/v2.1/token");
  const data = {
    grant_type: "authorization_code",
    code: code,
    redirect_uri: redirect,
    client_id: channelID,
    client_secret: client_secret,
  };
  return axios.post(url, qs.stringify(data), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
}

export {
  lineOAuth,
  vuexLineOAuth,
  imgbb,
  imgAWS,
  reverseGeocode,
  onemapAddress,
  graphhopperRoute,
  // googleMapsRoute,
  ipAddress,
  ipLookup,
};
